import React from 'react';
import { Link } from 'react-router-dom';
export function ProblemSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-345">
      <div className="max-w-7xl mx-auto px-5 md:px-12" data-id="element-346">
        <div className="max-w-3xl mx-auto text-center" data-id="element-347">
          <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-6" data-id="element-348">
            You shouldn't have to be your family's unpaid IT department
          </h2>
          <p className="text-base text-gray-600 leading-relaxed mb-6" data-id="element-349">
            Every week it's the same calls. A suspicious email. A locked
            account. A password that "stopped working." You love your family,
            but you shouldn't be the only thing standing between them and a
            disaster. Caveo guides each person through what they need to do,
            makes sure they finish, and keeps everyone in your household on the
            same page. No jargon. No tech knowledge required. Just the right
            actions, done.
          </p>

          <Link to="/onboarding" className="bg-[#1a0647] text-white px-7 py-3.5 rounded-md font-medium text-sm inline-flex items-center justify-center no-underline hover:bg-[#2a0a6e] transition-colors" data-id="element-350">
            See Where You Stand
          </Link>
        </div>
      </div>
    </section>;
}